import React from 'react';
import PropTypes from 'prop-types';

import {
  List,
  ListHeader,
  ListHeaderItem,
  ListBody,
  ListItem,
  ListItemColumn,
  Avatar,
} from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';

import { accountShape } from 'Workspace/types/account';

import { AvatarWrapper } from './styles';

import messages from './messages';

export const getAccountFullName = (account) => `${account.givenName || ''} ${account.familyName || ''}`.trim();

const sortAccountsList = (a, b) => (getAccountFullName(a).localeCompare(getAccountFullName(b)));

const AccountsList = ({ accounts }) => (
  <List>
    <ListHeader>
      <ListItemColumn>
        <ListHeaderItem>{intl.formatMessage(messages.listColumnHeaderTextName)}</ListHeaderItem>
      </ListItemColumn>
      <ListItemColumn>
        <ListHeaderItem>{intl.formatMessage(messages.listColumnHeaderTextEmail)}</ListHeaderItem>
      </ListItemColumn>
      <ListItemColumn>
        <ListHeaderItem>{intl.formatMessage(messages.listColumnHeaderTextRole)}</ListHeaderItem>
      </ListItemColumn>
    </ListHeader>
    <ListBody>
      {accounts.sort(sortAccountsList).map((account) => (
        <ListItem key={`account-item-${account.accountId}`}>
          <ListItemColumn>
            <AvatarWrapper>
              <Avatar avatar={account} />
            </AvatarWrapper>
            {getAccountFullName(account)}
          </ListItemColumn>
          <ListItemColumn>
            {account.primaryEmail}
          </ListItemColumn>
          <ListItemColumn>
            {account.roles.join(', ')}
          </ListItemColumn>
        </ListItem>
      ))}
    </ListBody>
  </List>
);

AccountsList.propTypes = {
  accounts: PropTypes.arrayOf(accountShape),
};

export default AccountsList;
